export class ScanSentToEditionComponent {
  file: {
    ServiceProprietaireId: number;
    SourceId: number;
    CentreNumId: number;
    DestinataireContactId: number;
    description: string;
    CodeClassementId: number;
  };
  blob: Blob;
  finished: boolean;
  scanGuid: string;
  splitGuid: string;
  type: string;
}
